import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { PaymentService } from '../../../../../services/payment.service';
import { map, Observable, Subject, take, takeUntil } from 'rxjs';
import { AppTableSource, ColumnSortType, TableColumnTypes } from '../../../../../model/table.model';
import { initUsersParams } from '../../../../../services/telegram.service';
import { IParams } from '../../../../../model/http';

export const tableHeaders = [
  {
    value: 'created_at',
    sort: ColumnSortType.NONE,
    name: 'created_at',
    type: TableColumnTypes.DATETIME,
    className: 'table-header',
    translate: true,
  },
  {
    value: 'status',
    sort: ColumnSortType.NONE,
    name: 'status',
    type: TableColumnTypes.PAYMENT_STATUS,
    className: 'table-header',
    translate: true,
  },
  {
    value: 'amount',
    sort: ColumnSortType.NONE,
    name: 'amount',
    type: TableColumnTypes.PRICE,
    className: 'table-header',
    translate: true,
  },
  {
    value: 'x_data',
    sort: ColumnSortType.NONE,
    name: 'description',
    type: TableColumnTypes.PAYMENT_INFO,
    className: 'table-header',
    translate: true,
  },
];

@Component({
  selector: 'app-payment-history-tab',
  standalone: false,
  templateUrl: './payment-history-tab.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './payment-history-tab.component.scss',
})
export class PaymentHistoryTabComponent implements OnInit {
  private readonly destroy$: Subject<null> = new Subject<null>();

  dataSource$: Observable<AppTableSource> = this.paymentService.history$.pipe(
    map((data) => {
      this.integrationTotal = data.total || 0;
      return {
        headers: tableHeaders,
        rows: data.items,
        pageSize: data?.size || 0,
        pageIndex: data.page ? data.page - 1 : 0,
        length: data.total || 0,
      };
    }),
  );
  visibleColumns = tableHeaders.map((v) => v.value);

  integrationTotal!: number;

  private usersRequest: any;
  public isLoader: boolean = false;

  constructor(private readonly paymentService: PaymentService) {}

  ngOnInit() {
    this.isLoader = true;
    this.paymentService
      .loadHistory()
      .pipe(takeUntil(this.destroy$), take(1))
      .subscribe((res: any) => {
        if (res) {
          this.isLoader = false;
        }
      });
  }

  getHistoryWithUpdatedParams(params: IParams) {
    if (this.usersRequest) {
      this.usersRequest.unsubscribe();
    }
    this.usersRequest = this.paymentService
      .setQueryListsParams(params)
      .pipe(takeUntil(this.destroy$), take(1))
      .subscribe();
  }

  onSortChange(e: any) {
    this.getHistoryWithUpdatedParams({
      ...initUsersParams,
      sort: e.active,
      order: e.direction,
    });
  }

  onPaginationChange(paginationDetails: any) {
    const { pageIndex, pageSize } = paginationDetails;
    const page = pageIndex + 1;
    const take = pageSize;
    this.getHistoryWithUpdatedParams({ page, take });
  }
}
